import subscribableDataStore from '@/shared/mixins/store/subscribableData';

const store = subscribableDataStore('/admin/rest/region');

export default { ...store };
